<div class="box" (keyup.enter)="canSearch() ? search() : null">

    <div class="header">
        <div class="content greendAnalityco">BUSCAR PROPIETARIO</div>
    </div>
    <div class="content-card list-card">

        <!-- Selector Persona Jurídica / Persona Natural -->
        <div class="fields-group-full">
            <mat-form-field class="input-field-full" appearance="fill">
                <mat-label>TIPO</mat-label>
                <mat-select [(ngModel)]="personType" (selectionChange)="onPersonTypeChange($event)" [disabled]="vehicleSelected.length > 0">
                    <mat-option value="JURIDICA">Persona Jurídica</mat-option>
                    <mat-option value="NATURAL">Persona Natural</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Card de propietario seleccionado -->
        <div class="card" *ngIf="vehicleSelected.length > 0">
            <div class="card-content">
                <img src="{{s3Bucket+etImgEmployer(vehicleSelected[0].Photo || vehicleSelected[0].Logo, vehicleSelected[0].DocumentType)}}" alt="">
                <div class="content-information">
                    <div class="ellipsis">{{vehicleSelected[0].Name || ''}}</div>
                    <div class="ellipsis baseline">{{vehicleSelected[0].DocumentType}}: {{vehicleSelected[0].DocumentNumber || ''}}</div>
                </div>
            </div>
            <mat-icon class="icon-close" (click)="setValuePersonal()">close</mat-icon>
        </div>

        <!-- Campos de documento -->
        <div class="fields-group" *ngIf="vehicleSelected.length === 0">
            <mat-form-field class="input-field-medium" appearance="fill">
                <mat-label>TIPO</mat-label>
                <mat-select [(ngModel)]="documentType" (selectionChange)="changeMaxCaracter($event)">
                    <mat-option *ngFor="let data of companyDocumentType" [value]="data.Value">
                        {{data.Value}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="input-field-100" appearance="fill">
                <mat-label>NÚMERO</mat-label>
                <input matInput type="text" [(ngModel)]="documentNumber" maxlength="{{maxCaracter}}" (ngModelChange)="validateNit()">
            </mat-form-field>
            <div *ngIf="documentType === 'NIT'" class="nitSeparator">-</div>
            <mat-form-field class="input-field-short" *ngIf="documentType === 'NIT'" appearance="fill">
                <input matInput type="text" [(ngModel)]="digito" maxlength="1" (ngModelChange)="validateNit()">
            </mat-form-field>
            <button mat-mini-fab class="btn-search-green" type="button" (click)="search()" matTooltip="Buscar" [disabled]="!canSearch()">
                <mat-icon>search</mat-icon>
            </button>
        </div>

        <div class="NITinvalido" *ngIf="documentType === 'NIT' && flagValidNit === false && vehicleSelected.length === 0">
            NIT invalido
        </div>

        <div class="actions-dialog-center">
            <button mat-button class="btn-cancelar" [mat-dialog-close]="null" [disabled]="isSaving">CANCELAR</button>
            <button mat-button class="btn-guardar" *ngIf="vehicleSelected.length > 0" (click)="saveOwner()" [disabled]="isSaving">GUARDAR</button>
        </div>
    </div>
</div>
